import * as React from 'react';
import { Card, Checkbox, Row, Col, Button, message } from 'antd';
import '../../../css/UploadProfileContentThree.scss';
import strings from '../../../eyeguide-localization/profile/strings.profile.bulkupload';
import CSVReader from 'react-csv-reader';

interface IUploadProfileContentTwoProps {
    handleNextClick: any;
    handlePrevClick: any;
    setFileName: any;
    isHeader: boolean;    
}

interface IUploadProfileContentTwoState {

    csvRows: Array<any>;    
    isHeader: boolean;
    pagination: any;    
    clearBtnDisable: boolean;
    loading: boolean;
    current: number;
}

export default class UploadContentTwo 
    extends React.Component<IUploadProfileContentTwoProps, IUploadProfileContentTwoState> {

    constructor(props: IUploadProfileContentTwoProps) {
        super(props); 
        this.state = {
            csvRows: [],    
            isHeader: props.isHeader,
            pagination: {}, 
            clearBtnDisable: false,
            loading: false,
            current: 1
        };

        this.handleFileLoad = this.handleFileLoad.bind(this);
    }

    componentWillReceiveProps(nextProp: any) {
        this.setState({
            isHeader : nextProp.isHeader
        });
    }

    render() {
        console.log('UploadContentTwo: ', this.state);
        return (
            <div className="UploadProfileContentThree">
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={3} xl={5} />
                    <Col xs={1} sm={1} md={2} lg={19} xl={19} className="labelFrame">
                    <Card bordered={false} style={{ margin: '24px 16px' }}> 
                        <CSVReader
                            cssClass="csv-input"
                            label={strings.lsSelectCSVFileTxt}
                            onFileLoaded={this.handleFileLoad}
                            onError={this.fileUploadError}
                        />
                        <Checkbox 
                            className="headerCheckbox" 
                            onChange={(val) => this.setState({isHeader: val.target.checked})}
                            checked={this.state.isHeader}
                        >
                            {strings.lsFirstRowHeaderChkBoxTxt} 
                        </Checkbox>
                        <Row>
                            <Button 
                                type="primary" 
                                onClick={() => this.clearForm()}
                                disabled={this.state.clearBtnDisable}
                            > 
                                {strings.lsClearTxt}
                            </Button>
                        </Row>                    
                    </Card>
                    </Col>
                </Row>
                <Row>
                    <Col span={10} style={{padding: '10px', width: '48%'}}>
                        <div className="buttonRight">
                            <Button 
                                onClick={e => this.props.handlePrevClick(1)}
                                type="danger" 
                                style={{width: '100%'}}
                            >
                                {'Previous'} 
                            </Button>
                        </div>
                    </Col>
                    <Col span={10} style={{padding: '10px'}}>
                        <div className="buttonLeft"> 
                            <Button 
                                type="primary" 
                                onClick={e => {                                    
                                    this.props.handleNextClick
                                    (
                                        {rows: this.state.csvRows, header: this.state.isHeader}, 
                                        2
                                    );
                                }}     
                                style={{width: '100%'}}
                                disabled={this.state.csvRows.length ? false : true}
                            > 
                            {'Next'} 
                            </Button>  
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    /**
     * Displays and sets the data fetched from csv uploaded
     * @param data Data fetched from csv as array to upload
     */
    
    private handleFileLoad(data: any, filename: any) {
        console.log('handleFileLoad', data);
        console.log('handleFileLoad.filename: ', filename);
        this.props.setFileName(filename);
        let dataRows = data.filter(row => {
            let cols = row.filter(col => col.trim().length > 0);
            return cols.length > 0 ? row : '' ; });

        this.setState({csvRows: []});      
        if (dataRows !== undefined && dataRows !== null && dataRows.length > 0) {
            this.setState({csvRows: dataRows, isHeader: this.state.isHeader}); 
        }
        
        console.log('csvRows', this.state.csvRows);        
        console.log('this.state.isHeader: ', this.state.isHeader);
    }

    /**
     * Clears the page
     */
    private clearForm() {
        let elm: any = document.getElementsByClassName('csv-input')[1];
        elm.value = '';
        let pagination = this.state.pagination;
        pagination.total = 0;
        this.props.setFileName('');
        this.setState({
            csvRows: [],
            loading: false,
            isHeader: false,
            pagination,
        });
    }

    private fileUploadError() {
        console.log('fileUploadError');
        message.error('File upload failed. Please try again!');
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/uploadprofilesteps/UploadProfileContentTwo.tsx